import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import {
  ProjectStateAsString,
  ProjectStatus,
} from 'controllers/Project/ProjectStateMachine'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { useAppSelector } from 'store/configureStore'
import { useProjectStateItem } from './useProjectStateItem'

export const ProductionStates = (props: { showStatus: ProjectStatus }) => {
  const {
    getStateTranslationKey,
    stateItemIsInPast,
    stateItemIsCurrent,
    classes,
    SavingComponent,
    changeStatus,
  } = useProjectStateItem(props.showStatus)

  const isBuyerView = useAppSelector(
    projectSelectors.ProjectInBuyerViewSelector
  )

  let className = ''

  if (stateItemIsCurrent()) {
    className = classes.active
  } else if (stateItemIsInPast()) {
    className = classes.produced
  } else {
    className = classes.disabled
  }

  const updateProjectState = () => {
    if (!isBuyerView) {
      changeStatus(
        ProjectStateAsString[
          ProjectStatus[props.showStatus + (stateItemIsCurrent() ? 1 : 0)]
        ]
      )
    }
  }

  return (
    <li
      className={className}
      style={{ cursor: isBuyerView ? 'default' : 'pointer' }}
      onClick={updateProjectState}
    >
      <LocalizedTypography
        translationKey={getStateTranslationKey()}
        variant="body2"
      />
      <SavingComponent />
    </li>
  )
}
